// extracted by mini-css-extract-plugin
export default {"current":"bl_j6","update":"bl_j7"};